import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'

function Library() {
    return (
        <>
            <Headerone />
            
            <Bredcom title="Home" subtitle="Library" />
            <section className="about-area about-p pt-60 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                    
                </div>
                <div className="container">
                    <div className='row pb-50'>
                        <div className='col-md-12'>
                            <div className='opecbtn'>
                                <a href='https://erp.mvn.edu.in/webOPAC/MVN/books' target='_blank'>MVN OPAC</a>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>MVN University Central Library</h3>
                                    <p>The MVN University Central Library has an extensive collection of academic books, reference materials, and online journals. The library provides a Book Bank facility, allowing students to issue books for the entire semester. It is subscribed to DELNET and INDEST, ensuring access to a wide range of eBooks, online journals, newspapers, and magazines.</p>
                                    <p>Our mission is to support the teaching, learning, and research needs of the MVN University community.</p>
                                    <p><b>Central Library: At a Glance</b></p>
                                </div>
                                <table className='table table-bordered tdfix'>
                                    <thead className='table-light head_red'>
                                        <tr>
                                            <th scope="col">Sr. No.</th>
                                            <th scope="col">Particulars</th>
                                            <th scope="col">Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Total Number of Volumes</td>
                                            <td>68,860</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Total Number of Titles</td>
                                            <td>9,262</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>International Journals</td>
                                            <td>04</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>National Journals</td>
                                            <td>19</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Newspapers</td>
                                            <td>12</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>Computers</td>
                                            <td>16</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>CDs</td>
                                            <td>1,205</td>
                                        </tr>
                                        <tr>
                                            <td>8</td>
                                            <td>Library Automation</td>
                                            <td>Yes (Vidya Library Management Software)</td>
                                        </tr>
                                        <tr>
                                            <td>9</td>
                                            <td>Digital Library</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>10</td>
                                            <td>Online Subscription</td>
                                            <td>Manupatra</td>
                                        </tr>
                                        <tr>
                                            <td>11</td>
                                            <td>Online Databases</td>
                                            <td>AIR Online Professional, AIR Supreme Court, Criminal Law Journal, AIR High Court</td>
                                        </tr>
                                        <tr>
                                            <td>12</td>
                                            <td>OPAC</td>
                                            <td>http://172.0.1.11/</td>
                                        </tr>
                                        <tr>
                                            <td>13</td>
                                            <td>Online Membership</td>
                                            <td>DELNET</td>
                                        </tr>
                                        <tr>
                                            <td>14</td>
                                            <td>Plagiarism Software</td>
                                            <td>Yes (DrillBit)</td>
                                        </tr>
                                        <tr>
                                            <td>15</td>
                                            <td>Total Library Area</td>
                                            <td>900 sq. m.</td>
                                        </tr>
                                        <tr>
                                            <td>16</td>
                                            <td>Seating Capacity</td>
                                            <td>250 Students</td>
                                        </tr>
                                        <tr>
                                            <td>17</td>
                                            <td>AIU eLibrary Membership</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>18</td>
                                            <td>Dissertations</td>
                                            <td>250</td>
                                        </tr>
                                        <tr>
                                            <td>19</td>
                                            <td>Old Question Papers</td>
                                            <td>Available</td>
                                        </tr>
                                        <tr>
                                            <td>20</td>
                                            <td>Theses</td>
                                            <td>80</td>
                                        </tr>
                                        <tr>
                                            <td>21</td>
                                            <td>Chief Librarian</td>
                                            <td>Dr. K. K. Jha</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <p><b>Library Team</b></p>
                                <table className='table table-bordered tdfix'>
                                    <thead className='table-light head_red'>
                                        <tr>
                                            <th scope="col">Sr. No.</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Designation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Dr. Kishor Kumar Jha</td>
                                            <td>Chief Librarian</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Suman Indora</td>
                                            <td>Deputy Librarian</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Prakash Chandra Behera</td>
                                            <td>Assistant Librarian</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>Hitesh Kumar</td>
                                            <td>Library Assistant</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Gajendra</td>
                                            <td>Library Attendant</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='lbteam'>
                                            <img src='/assets/img/lbteam-1.jpg'/>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='lbteam'>
                                            <img src='/assets/img/lbteam-2.jpg'/>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <h4>Contact Information</h4>
                                <p>Chief Librarian: Dr. K. K. Jha<br /> Contact Number: 7827293693<br /> Email: librarian@mvn.edu.in</p>
                                <br />
                                <h4>Address</h4>
                                <p>74th Km Stone, NH-2, Delhi-Agra Highway (NCR)<br /> Haryana – 121105</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Library